module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAABTUlEQVRIx2NgmGpAKzRq9AAbzT7DLGRHSfCOYrdNmcarIvlmWwMZJUf78g53em3JCd1RCmR4bM7KP9zlvSXXbHUMCUYbrAyfdGl5+9l5zhvTVJf4mayOitxVMfvqOuUlPlkH24Ds3EMduitCe84vsluf5LM1jwSjWaebAA313ZrfdHqW39Z8o1WRrpsygM4vPNITvbvKfXNWzqEO+UWemQdbI3aVAx1OgtEcM8yAxgENBWqWmO8M1Fx6rH/34xP9F5ZYr0sAchP21qks8Q3YVgg02mJNLGkBkryvoffCoqDtxVUnJgNNBAZuzcmpwAARnecIDHdgmADNBdphvz5ZaoEraSmEcaohMFiAJBDxzrKGeAUSVszTjCBqgAwmGHuEZxlIEJFvtPh8Z2D6rT4xBRiTZccmAFMekAtMM6n7m4AirWfmAHPNaPE03I0GAH92EMoomvZZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/sa.png
// module id = 374
// module chunks = 0